import React, { lazy } from 'react';
import { motion } from 'framer-motion';
type Member = {
  name: string;
  role: string;
  image: string;
};
const leadership: Member[] = [{
  name: 'Ajayi, Osagioduwa Joseph',
  role: 'General Coordinator & Founder',
  image: 'https://cdn.magicpatterns.com/uploads/oHW8WEVHdoxER22aeeA1KN/AJAYI,_OSAGIODUWA_JOSEPH_-_GENERAL_COORDINATOR,_CDPP.jpg'
}, {
  name: 'Mattu Benedict Robert',
  role: 'Assistant General Coordinator',
  image: 'https://cdn.magicpatterns.com/uploads/4yHquDsvSZJ3qofLTq43k7/MATTU_BENEDICT_ROBERT,_ASSISTANT_GENERAL_COORDINATOR.jpg'
}, {
  name: 'Oniovosa Okuyade Prosper',
  role: 'General Secretary',
  image: 'https://cdn.magicpatterns.com/uploads/2xT2Qc61u2Sk9mkjrkJpFd/ONIOVOSA_OKUYADE_PROSPER,_GENERAL_SECRETARY.jpg'
}, {
  name: 'Divine Omonigho Areghan',
  role: 'Assistant General Secretary',
  image: 'https://cdn.magicpatterns.com/uploads/jfEJMV5kUKxm99LfQF8FnH/DIVINE_OMONIGHO_AREGHAN,_ASSISTANT_GENERAL_SECRETARY.jpg'
}, {
  name: 'Royalty Osadebawen Ogiobadan',
  role: 'Treasurer & Chairperson, FMC',
  image: 'https://cdn.magicpatterns.com/uploads/qCooPnBNnAeYBwKB9DycRT/ROYALTY_OSADEBAWEN_OGIOBADAN,_TREASURER__CHAIRPERSON,_FINANCE_MANAGEMENT_COMMITTEE_(FMC).jpg'
}, {
  name: 'Osemwengie Barry Edosomwan',
  role: 'Budget Planning Officer',
  image: 'https://cdn.magicpatterns.com/uploads/1AcWMn9nKoVUHtbUpxn47c/OSEMWENGIE_BARRY_EDOSOMWAN,_BUDGET_PLANNING_OFFICER.jpg'
}, {
  name: 'Ovigue Catherine Akerele',
  role: 'Programs Coordinator',
  image: 'https://cdn.magicpatterns.com/uploads/1HottLPJ4MqGcCMN9VVw2h/OVIGUE_CATHERINE_AKERELE,_PROGRAMS_COORDINATOR.jpg'
}, {
  name: 'Marvelous Obasuyi',
  role: 'Outreach Coordinator',
  image: 'https://cdn.magicpatterns.com/uploads/xwpGSx3MW1m2gAJpKYbAN6/MARVELOUS_OBASUYI,_OUTREACH_COORDINATOR.jpg'
}, {
  name: 'Royal Oniovosa',
  role: 'Media Coordinator & Publicity Sec.',
  image: 'https://cdn.magicpatterns.com/uploads/qKf7yyLceo2y4Fpw9BjrFW/ROYAL_ONIOVOSA,_MEDIA_COORDINATOR__PUBLICITY_SECRETARY.jpg'
}, {
  name: 'Josephine Ojamayoma',
  role: 'Assistant Media & Assistant Publicity Sec.',
  image: 'https://cdn.magicpatterns.com/uploads/oQaZCMvDPKvbPT9k3nxNT4/IMG_20260510_092653.jpg'
}];
export function TeamPage() {
  return <main className="flex-grow pt-24" data-id="element-547">
      <div className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-548">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-549" />

        <div className="relative z-10" data-id="element-550">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-551">
            Leadership
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6" data-id="element-552">
            Meet Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-553">
              Team
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto px-6" data-id="element-554">
            The servants leading Camp David Prayer Platform — standing in the
            gap, and equipping a generation of intercessors.
          </motion.p>
        </div>
      </div>

      <section className="py-32 bg-ivory text-midnight" data-id="element-555">
        <div className="max-w-7xl mx-auto px-6" data-id="element-556">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-557">
            {leadership.map((member, idx) => <motion.div key={member.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: idx * 0.05
          }} className="group bg-white p-4 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300" data-id="element-558">
                <div className="relative overflow-hidden rounded-[1.5rem] bg-midnight/5 aspect-square mb-6" data-id="element-559">
                  <img src={member.image} alt={member.name} loading="lazy" decoding="async" className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700 ease-out" data-id="element-560" />
                  <div className="absolute inset-0 bg-gradient-to-t from-midnight/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-561" />
                </div>
                <div className="px-2 pb-2" data-id="element-562">
                  <h3 className="text-xl font-display font-bold text-midnight leading-tight mb-2" data-id="element-563">
                    {member.name}
                  </h3>
                  <p className="text-xs uppercase tracking-widest text-gold font-bold" data-id="element-564">
                    {member.role}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-32 text-center max-w-3xl mx-auto bg-midnight text-ivory p-12 rounded-[3rem] rotate-1 shadow-2xl" data-id="element-565">
            <p className="font-serif italic text-2xl md:text-4xl leading-snug" data-id="element-566">
              "We are watchmen on the walls — called to stand in the gap, to
              pray without ceasing, and to raise Kingdom Giants for the
              harvest."
            </p>
          </div>
        </div>
      </section>
    </main>;
}